import React from 'react';
import { updateFilter, clearAll } from '!/actions/creators';
import { connect } from 'react-redux';
import Categories from '../Categories/Categories';
import ClearAll from '../ClearAll/ClearAll';
import WidgetTypes from '../Filters';
import RadioSort from '../Sorting/Radio';
import WidgetContainer from '../WidgetContainer/WidgetContainer';
import { getLocale, addGAEventTracking } from '!/common/helpers';
import { useState, useEffect } from 'react';
import { PromotedFilters } from '@web/vitafy-react-components';


const actions = { updateFilter, clearAll };

const Widgets = props => {
  const { widgets, aggs, settings, applied, total, values, updateFilter, storeCode } = props;
  const expandFiltersLimit = settings.openFilterLimit[storeCode] || settings.openFilterDefaultLimit;

  const isHorizontal = 
    (typeof document !== 'undefined' &&
     document.body.classList.contains("horizontal-navigation"));
  const [widgetsOpenState, setWidgetsOpenState] = useState(
    [...widgets, "sort"].map((_, i) => isHorizontal ? false : i < expandFiltersLimit));
  const [overlayOpen, setOverlayOpen] = useState(false);

  const toggleOverlay = open => {
    document.body.classList[open ? 'add' : 'remove']('no-overflow');
    setOverlayOpen(open);
    if (open) {
      setWidgetsOpenState(widgetsOpenState.map(_ => false));
    }
  };

  const toggleWidgetOpenStateExclusive = widgetIndex => 
    setWidgetsOpenState(widgetsOpenState.map(
      (_, i) => i === widgetIndex ? !widgetsOpenState[widgetIndex] : false));

  const toggleWidgetOpenStateIndividual = widgetIndex => 
    setWidgetsOpenState(widgetsOpenState.map(
      (_, i) => i === widgetIndex ? !widgetsOpenState[widgetIndex] : widgetsOpenState[i]));

  const toggleWidgetOpenState = widgetIndex => 
    overlayOpen ? 
      toggleWidgetOpenStateExclusive(widgetIndex) :
      toggleWidgetOpenStateIndividual(widgetIndex);

  const closeAllWidgets = _ => setWidgetsOpenState(widgetsOpenState.map(_ => false));
  

  useEffect(_ => {
    document.body.classList[widgetsOpenState.indexOf(true) != -1 ? 'add' : 'remove']('search-filter-open');
  }, [widgetsOpenState]); 

  return (
    <>
    <PromotedFilters {...props} toggleOverlay={toggleOverlay} />
    <aside className="search-layout__promoted">
      <Categories open={true} />
    </aside>
    <aside id="widgets" className="search-layout__widgets">
      <button className="btn btn--outline btn--block show-for-small search-layout__filter-button" onClick={() => toggleOverlay(true)}
        {...addGAEventTracking('Mobile Filter', 'Search Filter', 'open')}>
        Filter
        {(applied.length > 0) ? <span className="search-layout__applied"> {applied.length} </span> : ''}
      </button>
      <div className={ `overlay ${overlayOpen ? 'overlay--visible' : ''}` } data-type="overlay">
        <div className="overlay__header show-for-small">
          <h3>Filtern</h3>
          {applied.length > 0 && <ClearAll key={1} />}
        </div>
        <form action="/search" method="GET" className="overlay__content">
          <Categories />

          <RadioSort title={'Sortieren'} name={'sort'} 
            mobileOnly={true} widgetIndex={widgets.length} 
            toggleWidgetOpenState={_ => toggleWidgetOpenState(widgets.length)}
            {...{widgetsOpenState}} />

          { widgets.map((widget, index) => {
            const { name, type, title } = widget;
            const Widget = WidgetTypes[type]

            if (widget.type !== 'slider' &&
                (!Widget || !aggs[name] || !aggs[name].filter || !aggs[name].filter(a => a.value !== '').length)) {
              return null;
            }

            return (
              <WidgetContainer update={updateFilter} key={name} widgetIndex={index}
                showUtils={aggs[name].length > 9} toggleWidgetOpenState={_ => toggleWidgetOpenState(index)}
                {...{title, name, values, widgetsOpenState}}>
                <Widget parentIndex={index} update={updateFilter} {...{name, values, aggs, total, title}} />
              </WidgetContainer>
            );
          })}

        </form>
        <div className="overlay__footer show-for-small">
          <button className="btn btn--fnl" aria-label={getLocale('Close Filters')} onClick={_ => { toggleOverlay(false); closeAllWidgets(); }}>
            {getLocale(applied.length > 0 ? 'Show %s Results' : 'Filter schliessen', total)}
          </button>
        </div>
      </div>
    </aside>
    </>
  );
};

function mapStateToProps({ widgets, aggs, settings, applied, total, values, storeCode }) {
  return {
    widgets,
    aggs,
    settings,
    applied,
    total,
    values,
    storeCode
  };
}

export default connect(
  mapStateToProps,
  actions
)(Widgets);
